import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { ROUTES, getRouteTitle } from '../constants/RouteNameMapping';

const financeRegex = new RegExp(/\/finance\/\d/);
const portfolioRegex = new RegExp(/\/portfolio\/\d/);
const companyProfileRegex = new RegExp(/\/company-profiles\/*/i);

export const useTitle = () => {
  const [title, setTitle] = useState('Portfolio Reporting');
  const { pathname } = useLocation();

  useEffect(() => {
    if (financeRegex.test(pathname)) {
      return setTitle(getRouteTitle(ROUTES.FINANCE_HISTORY));
    }
    if (pathname.startsWith(`/${ROUTES.FINANCE2}/`)) {
      return setTitle(getRouteTitle(ROUTES.FINANCE2));
    }
    if (pathname.startsWith(`/${ROUTES.INTEGRATIONS}/`)) {
      return setTitle(getRouteTitle(ROUTES.INTEGRATIONS));
    }
    if (portfolioRegex.test(pathname)) {
      return setTitle(getRouteTitle(ROUTES.PORTFOLIO));
    }
    if (companyProfileRegex.test(pathname)) {
      return setTitle(getRouteTitle(ROUTES.COMPANY_PROFILES));
    }
    if (pathname.includes('deal-flow')) {
      return setTitle(getRouteTitle(ROUTES.DEAL_FLOW));
    }
    if (pathname.includes('admin-panel')) {
      return setTitle(getRouteTitle(ROUTES.ADMIN_PANEL));
    }
    if (pathname.includes('kpis')) {
      return setTitle(getRouteTitle(ROUTES.KPI));
    }
    if (pathname.includes('companies')) {
      return setTitle(getRouteTitle(ROUTES.COMPANIES));
    }
    if (pathname.startsWith(`/${ROUTES.DOCS}`)) {
      return setTitle(getRouteTitle(ROUTES.DOCS));
    }
    if (pathname.startsWith(`/${ROUTES.ENTITIES}`)) {
      return setTitle(getRouteTitle(ROUTES.ENTITIES));
    }

    setTitle(getRouteTitle(pathname) ?? getRouteTitle(pathname.slice(1)) ?? 'Portfolio Reporting');
  }, [pathname]);

  return title;
};
